import { useUser } from "@/queries/user/useUser";
import { Navigate } from "react-router";
import LoadingSection from "../LoadingSection";
import { UserStatus } from "@/api/SolarCloudApi";
import { useProfileContext } from "@/contexts/ProfileContext";

export default function BuySolarRouteGuard({ children }: { children: React.ReactNode }) {
  const { data: user, isLoading } = useUser();
  const { isAuthenticationLoading } = useProfileContext();

  if (isAuthenticationLoading || isLoading) {
    return <LoadingSection />;
  }

  if (!user || user.status !== UserStatus.ACTIVE) {
    return <Navigate to="/buypanels" replace />;
  }

  return <>{children}</>;
}
